module.exports = __webpack_public_path__ + "img/credit_card_default.e5f2be4.svg";